import { SimpleHandler } from '../types/@types/sl-v-types';

export type WebFile = File;

export class FileResource {
	private file: WebFile
	private reader: FileReader;
	public readerReady = false;
	public get fileName(): string {
		if (!this.file) {
			return '';
		}
		return this.file.name;
	}
	public get fileSize(): number {
		if (!this.file) {
			return 0;
		}
		return this.file.size;
	}

	public get mimeType(): string {
		if (!this.file) {
			return '';
		}
		return this.file.type;
	}
	public get data(): string {
		if(this.readerReady === false) {
			return null;
		}
		return btoa(this.reader.result as string);
	}
	constructor(file: WebFile,handler:SimpleHandler) {
		this.file = file;
		this.reader = new FileReader();
		this.reader.readAsBinaryString(this.file);
		this.reader.onload = () => {
			this.readerReady = true;
			handler();
		}
	}


}